import React from 'react';

import { AppTable, AppTableColumn } from 'components/table/appTable';
import { MoEventDetailsTableProps } from './MoEventDetailsTable.types';
import { Participant } from 'api/mo/mo.types';

const formatValue = (value: any) => value || '';

const columns: AppTableColumn[] = [
  {
    columns: [
      {
        Header: 'Full Name',
        id: 'fullName',
        accessor: (participant: Participant) => formatValue(participant.fullName),
      },
      {
        Header: 'Subtitle',
        id: 'subtitle',
        accessor: (participant: Participant) => formatValue(participant.subtitle),
      },
      {
        id: 'clientParticipantId',
        show: false,
        accessor: () => formatValue(undefined),
      },
      {
        Header: 'Id',
        id: 'marchingOrderParticipantId',
        accessor: (participant: Participant) => formatValue(participant.id),
      },
      {
        Header: 'Email',
        id: 'email',
        accessor: (participant: Participant) => formatValue(participant.email),
      },
      { id: 'snapcodeId', show: false, accessor: () => formatValue(undefined) },
    ],
  },
];

export const MoEventDetailsTable = (props: MoEventDetailsTableProps) => {
  const { data } = props;

  return (
    <AppTable columns={columns} data={data} tableName="events" noDataText="No data to display" defaultPageSize={10} />
  );
};
